// extracted by mini-css-extract-plugin
module.exports = {"balloon":"dece2e673c--balloon--Cfqtx","icon":"dece2e673c--icon--z0_Vg"};